import React, { useState } from 'react';
import { MoreVertical, Eye, Heart, Save, SaveIcon } from 'lucide-react';
import { useNavigate } from 'react-router';


interface ActionDropdownProps {
  vehicleId: number | undefined;
  itemId: number | undefined;
  itemType: string; 
  whatComponenr: string; // e.g., 'workstation', 'vehicle', 'buiding', 'work instruction' etc.
}

const ActionDropdown: React.FC<ActionDropdownProps> = ({ vehicleId,itemId, itemType }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleView = () => {
    // Navigate based on item type
    // switch (itemType) {
    //   case 'body-shop':
    //     navigate(`/vehicle/${vehicleId}/building/${itemType}/workstation/${itemId}`);
    //     break;
    //   case 'chassis-line':
    //     navigate(`/vehicle/${vehicleId}/building/${itemType}/workstation/${itemId}`);
    //     break;
    //   case 'paint-shop':
    //     navigate(`/vehicle/${vehicleId}/building/${itemType}/workstation/${itemId}`);
    //     break;
    //   case 'trim-line':
    //     navigate(`/vehicle/${vehicleId}/building/${itemType}/workstation/${itemId}`);
    //     break;
    //   case 'QIT':
    //     navigate(`/vehicle/${vehicleId}/building/${itemType}/workstation/${itemId}`);
    //     break;
    //   case 'vehicle':
    //     navigate(`/vehicle/${itemId}`);
    //     break;
    //   case 'WS1':
    //     navigate(`/vehicle/${vehicleId}/building/${itemType}/workstation/${itemId}/workinstruction/${itemId}`);
    //     break;
    //   case 'WS2':
    //     navigate(`/vehicle/${vehicleId}/building/${itemType}/workstation/${itemId}/workinstruction/`);
    //     break;
    //   default:
    //     navigate(`/${itemType}/${itemId}`);
    // }
    if (!vehicleId || !itemId) return;
    
    // If the action is for a vehicle, navigate directly to its page.
    if (itemType === 'vehicle') {
      navigate(`/vehicle/${itemId}`);
    } else {
      // For workstation types (e.g., body-shop, chassis-line, etc.),
      // route to the dynamic workstation page.
      navigate(`/vehicle/${vehicleId}/building/${itemType}/workstation/${itemId}`);
    }

    setIsOpen(false);
  };

  const handleFavourite = () => {
    // Add favourite logic here
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 hover:bg-gray-100 rounded-full"
      >
        <MoreVertical className="w-5 h-5 text-gray-600" />
      </button>

      {isOpen && (
        <>
          {/* Overlay to close dropdown when clicking outside */}
          <div 
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />

          {/* Dropdown Menu */}
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg z-20 overflow-hidden">
            <button
              onClick={handleView}
              className="flex items-center w-full px-4 py-3 text-left hover:bg-gray-50"
            >
              <Eye className="w-5 h-5 mr-3" />
              <span className="text-lg">View</span>
            </button>
            
            <button
              onClick={handleFavourite}
              className="flex items-center w-full px-4 py-3 text-left hover:bg-gray-50"
            >
              <Save className="w-5 h-5 mr-3" />
              <span className="text-lg">Save</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ActionDropdown;